<template>
  <v-checkbox
    v-model="$data[opts.key]"
    :name="opts.key"
    color="primary"
  >
    <template #label>
      <small>{{ label }}</small>
    </template>
    <template #append>
      <v-tooltip top>
        <template #activator="{ on }">
          <v-icon v-on="on">
            mdi-information-outline
          </v-icon>
        </template>
        {{ description }}
      </v-tooltip>
    </template>
  </v-checkbox>
</template>
<script>
export default {
  name: "Checkbox",
  props: {
    opts: {
      type: Object,
      default() {
        return {};
      }
    },
    config: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    let data = {};
    let key = this.opts.key;
    data[key] = this.opts.value || null;
    return data;
  },
  computed: {
    label() {
      return (
        this.opts.name[this.$i18n.locale] +
        (this.opts.required != undefined && this.opts.required == true
          ? "*"
          : "")
      );
    },
    description() {
      return this.opts.description[this.$i18n.locale];
    }
  },
  watch: {
    opts: {
      handler({value, key}) {
        if(value && key) {
          this[key] = value;
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.config != null) this.$data[this.opts.key] = this.config;
  },
  methods: {}
};
</script>